import React, { ReactNode } from "react";
import { api } from "api/api";
import MacroButton, {
  MacroBulletItem,
  MacroBulletList,
  MacroContentStack,
} from "./MacroButton.component";
import { DialogContentText } from "@mui/material";

export default function AddPriceKeySubpropertyLookupButton() {
  function InfoMessage(): ReactNode {
    return (
      <MacroContentStack>
        <DialogContentText>
          This process will find all lookup tables where a .MLP subproperty with
          a .PRICEKEY subproperty under the same parent is looked up in this
          product line. It will then add the .PRICEKEY subproperty as a lookup
          column to each of these tables. See additional details below:
        </DialogContentText>
        <MacroBulletList>
          <MacroBulletItem>
            The .PRICEKEY subproperty will not be added to a lookup table that
            already uses it in any column. So this process can be run multiple
            times without causing issues.
          </MacroBulletItem>
          <MacroBulletItem>
            This macro does not create new .PRICEKEY subproperties. For this
            functionality, run the macro to add the .PRICEKEY subproperty to the
            product line before running this.
          </MacroBulletItem>
          <MacroBulletItem>
            .MLP subproperties that do not have the <strong>FLOAT</strong> data
            type and .PRICEKEY subproperties that do not have the{" "}
            <strong>STRING</strong> data type will be ignored.
          </MacroBulletItem>
          <MacroBulletItem>
            It will be assumed that your tables do not have validation errors
            when running this macro. To avoid unexpected behavior, it is
            recommended that you validate your product line and fix all table
            validation <strong>ERRORS</strong> before running this.
          </MacroBulletItem>
        </MacroBulletList>
        <DialogContentText>
          Are you sure you want to continue?
        </DialogContentText>
      </MacroContentStack>
    );
  }

  return (
    <MacroButton
      performApiCall={(productLineId: string) =>
        api.addPriceKeySubpropertyLookupColumns(productLineId)
      }
      apiCallDependencies={[]}
      buttonLabel={`Add .PRICEKEY Lookup Columns to Product Line`}
      dialogTitle={`Add .PRICEKEY Lookup Columns to Product Line`}
      tooltipText={`Adds .PRICEKEY lookup columns to the product line.`}
      processingMessage={`Adding .PRICEKEY lookup columns to product line. This may take a while.`}
      completionMessage="Addition completed. See detailed results below."
      timeOutMessage="Addition process timed out. See details below."
      informationContent={InfoMessage()}
      timeOutFailureDescription={`Request timed out. This could be due to an 
        especially large number of .PRICEKEY instances to add lookup columns for.`}
      pvasUpdated={false}
      recommendValidation={true}
    />
  );
}
